import React, { useEffect, useState } from 'react';
import Typewriter from 'react-typewriter-effect';
import Bg1 from '../assets/gif1.gif'
import Bg2 from '../assets/gif2.gif'
import Bg3 from '../assets/gif3.gif'
import Bg4 from '../assets/gif4.gif'

const gifs = [Bg1, Bg2, Bg3, Bg4];
const gifDisplayDuration = 8000; // 8 segundos


const Hero = () => {

  // const [randomIndex, setRandomIndex] = useState(0);

  // useEffect(() => {
  //   const randomNum = Math.floor(Math.random() * gifs.length);
  //   setRandomIndex(randomNum);
  // }, []);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setElapsedTime(prevElapsedTime => prevElapsedTime + gifDisplayDuration);
    }, gifDisplayDuration);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const newIndex = Math.floor(elapsedTime / gifDisplayDuration) % gifs.length;
    setCurrentIndex(newIndex);
  }, [elapsedTime]);

  return (
    <div id="hero-section" className='w-full h-screen '>
      <img
        className='top-0 left-0 w-full h-screen object-cover -mt-14'
        src={gifs[currentIndex]}
        alt='/'
      />
      <div className='bg-black/30 absolute top-0 left-0 w-full h-screen mt-2' />
       <div className='absolute top-0 w-full h-full flex flex-col justify-center text-white '>
        <div className='md:left-[10%] max-w-[1100px] m-auto absolute p-4 space-y-4 '>

          <div className='flex flex-col font-bold text-5xl md:text-7xl drop-shadow-2xl ml-4 '>
            <div className='flex flex-row'>
              <Typewriter
                textStyle={{
                  fontWeight: 'bold',
                  fontSize: '5xl',
                  textShadow: '0 0 25px rgba(0, 0, 0, 0.5)',
                  color: 'white',
                  fontFamily: 'inherit',
                }}
                startDelay={2000}
                multiText={['Renderiz', 'Inov', 'Transform']}
                cursorColor=""
                multiTextDelay={3000}
                typeSpeed={200}
                multiTextLoop
              />
              <h1 >
                ação 
              </h1>
            </div>
              <h1>
              arquitetônica
              </h1>
            </div>


          <p className='max-w-[600px] drop-shadow-2xl py-2 text-xl pl-10'>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo ut quis
            est, id consequuntur sequi ipsum vitae sit non exercitationem.
            
          </p>
        <div className='max-w-[600px] drop-shadow-2xl py-2 text-xl pl-10'>
          <button className='font-bold bg-white text-black '>Conheça</button>
        </div>

        </div>
      </div>
    </div>
  );
};

export default Hero;